import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  container: css`
    display: flex;
    flex-direction: row;
    padding: 8px 0px 16px;
    overflow: scroll;
    @media (display-mode: browser) {
      overflow: auto;
    }
    ::-webkit-scrollbar {
      width: 0px;
    }
  `,
  card: css`
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${colors.prussianMid};
    & + div {
      margin-left: 17px;
    }
  `,
  text: css`
    padding-left: 5px;
    font-family: 'Proxima Nova';
    font-size: 14px;
    white-space: nowrap;
  `,
};

export default styles;
